<template>
  <LayoutPage
    v-if="showPreviousDecision"
    :provider-key="providerKey"
    :title="t('apply.decision.heading')"
  >
    <ApplyDeclinedDecision
      v-if="responseCode === 'declined'"
      :response="providerResponse"
      transitioning
    />

    <ApplyNoOfferDecision
      v-else-if="responseCode === 'nooffer'"
      :response="providerResponse"
      transitioning
    />

    <ApplyPendingOfferDecision
      v-else-if="responseCode === 'pending' && softHit"
      :response="providerResponse"
      transitioning
    />

    <ApplyPendingFullDecision
      v-else-if="responseCode === 'pending' && !softHit"
      :response="providerResponse"
      transitioning
    />

    <i18n-t v-else :keypath="`apply.responses.${responseCode}.message`" />
  </LayoutPage>
</template>

<script setup lang="ts">
  import { overrideCurrentProvider } from "@versatile-credit-apply/composition"
  import { computed } from "vue"
  import ApplyNoOfferDecision from "@/components/apply/ApplyNoOfferDecision.vue"
  import ApplyDeclinedDecision from "@/components/apply/ApplyDeclinedDecision.vue"
  import { ProviderApplyOperation } from "@versatile-credit-apply/omni-apply-client"
  import ApplyPendingOfferDecision from "@/components/apply/ApplyPendingOfferDecision.vue"
  import ApplyPendingFullDecision from "@/components/apply/ApplyPendingFullDecision.vue"
  import type { CascadedApplicationResponse } from "@versatile-credit-apply/sdk"
  import { useI18n } from "vue-i18n"

  type Props = {
    response: CascadedApplicationResponse
  }

  const props = defineProps<Props>()

  const providerResponse = computed(() => props.response?.provider)
  const providerKey = computed(() => providerResponse.value?.providerKey)
  const responseCode = computed(() => providerResponse.value?.responseCode)
  const softHit = computed(() => {
    return ProviderApplyOperation.isSoftHit(providerResponse.value?.operation)
  })

  overrideCurrentProvider(providerKey)

  const { t } = useI18n()

  const showPreviousDecision = computed(
    () => props.response && !props.response.next?.requireUserAction // requireUserAction stops cascade for decision
  )
</script>

<i18n lang="yaml" locale="en">
apply:
  decision:
    heading: Decision
</i18n>
